<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>publication</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="publicationsbox">
      <!-- <p class="title">{{tabActive}}</p> -->
      <div class="f_r">
        <el-select v-model="yearsData" placeholder="请选择" @change="yearChangeFn()">
          <el-option
            v-for="item in yearsList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <ul class="publicationsul">
        <li v-for="(item,key) in pdfList" :key="key">
          <p class="title">
            <router-link
              :to="{name:'publicationsMain',params:{id:item.id}}"
              @click.native="gotoMain(item.id)"
            >{{item.title}}</router-link>
          </p>
          <p class="mainText">{{item.info}}</p>
          <div class="mainImg">
            <img :src="item.cover">
          </div>
        </li>
      </ul>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[5]"
        :page-size="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import "@/assets/css/publications.less";
import apiSign from "../assets/js/apiSign";
const years = [
  { value: "请选择出版物年份", label: "请选择出版物年份" },
  { value: "2020", label: "2020" },
  { value: "2019", label: "2019" },
  { value: "2018", label: "2018" },
  { value: "2017", label: "2017" },
  { value: "2016", label: "2016" }
];
export default {
  data() {
    return {
      pdfList: [],
      total: 0,
      pdfId: "",
      yearsList: years,
      yearsData: "请选择出版物年份",
    };
  },
  created() {
    this.getPdfListFn();
  },
  
  watch: {
    '$store.state.membersYear'() {
      this.yearsData = this.$store.state.membersYear
      this.yearChangeFn()
    }
  },
  methods: {
    getPdfListFn() {
      let field = { rtime: apiSign.getTime() };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/publications/lists", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          this.pdfList = resp.data.data.data;
          this.total = resp.data.data.total;
        });
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val, year) {
      let field = { rtime: apiSign.getTime(), page: val };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/publications/lists", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          if (resp.data.code == 0) {
            this.pdfList = resp.data.data.data;
            this.total = resp.data.data.total;
            let timer = setInterval(function() {
              var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
              var ispeed = Math.floor(-scrollTop / 6);
              if (scrollTop == 0) {
                clearInterval(timer);
              }
              document.documentElement.scrollTop = document.body.scrollTop =
                scrollTop + ispeed;
            }, 30);
          }
        });
    },
    yearChangeFn() {
      let year = this.yearsData;
      year == '请选择出版物年份' ? year = '':year = year;
      let field = { rtime: apiSign.getTime(), page: 1, year: year };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/publications/lists", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          if (resp.data.code == 0) {
            this.pdfList = resp.data.data.data;
            this.total = resp.data.data.total;
            let timer = setInterval(function() {
              var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
              var ispeed = Math.floor(-scrollTop / 6);
              if (scrollTop == 0) {
                clearInterval(timer);
              }
              document.documentElement.scrollTop = document.body.scrollTop =
                scrollTop + ispeed;
            }, 30);
          }
        });
    },
    gotoMain(id) {
      this.$store.state.pdfId = id;
      sessionStorage.setItem("pdfId", id);
    }
  }
};
</script>
<style>
</style>

